<template>
    <tr>
        <td v-if="editing"><input class="small" type="date" id="start" name="start_date" v-model='status.start_date'></td>
        <td v-else v-on:click="edit()">{{ status.start_date }}</td>

        <td v-if="editing"><input class="small" type="date" id="end" name="end_date" v-model='status.end_date'></td>
        <td v-else v-on:click="edit()">{{ status.end_date }}</td>

        <td>{{ status.status_type }}</td>
        <td>{{ status.staff }}</td>
        <td><a v-on:click="showStatus(status)">read</a></td>

        <td v-if="!editing"><notification-status v-bind:status="status" v-bind:key="status.id"></notification-status></td>
        <td v-else><a class="bg-danger btn-sm" v-on:click="cancel()">Cancel</a></td>

        <td v-if="!editing"><a v-on:click="deleteStatus()">Delete</a></td>
        <td v-else><a class="bg-primary btn-sm" v-on:click="updateStatus(status)">Save</a> </td>

    </tr>
</template>

<script>
    import { EventBus } from '../app.js';
    export default {
        props: ['status'],
        data() {
            return {
              editing:false,
              original_start:"",
              original_end:"",
            };
        },
        mounted() {
          this.original_start = this.status.start_date;
          this.original_end = this.status.end_date;
        },
        methods: {
            deleteStatus: function(event){

                // api call
                axios.post("./api/status/delete/" + this.status.id).then(response => {
                    this.$alert.success({
                        message: 'Status removed.'
                    });
                    this.$parent.loadStatuses();
                })
                .catch(error => {
                    this.$alert.danger({
                        message: 'Error: ' + error.response.data.message
                    });
                    this.$parent.loadStatuses();
                });

            },
            showStatus(status) {
                EventBus.$emit('show_status', status);
            },
            updateStatus(status){
              var self = this;


              var atts ={
                'start_date': status.start_date,
                'end_date': status.end_date,
              }

              if (!this.compareDates(atts)) {

                this.$alert.warning({ message: 'The start date must be before the end date' })
                return;
              }


              axios.post("./api/status/update/" + this.status.id, atts)
                .then((response) => {

                  this.$alert.success({ message: response.data.message })
                  self.editing = false;
                  self.original_start = self.status.start_date;
                  self.original_end = self.status.end_date;
                }, (error) => {

                  this.$alert.danger({ message: 'There was an error. Please reload the page and try again.' });
                });


            },
            cancel(){
              this.editing = false;
              this.status.start_date = this.original_start;
              this.status.end_date = this.original_end;
            },
            edit(){
              this.editing = true;
            },
            compareDates(dates){

              //prep dates
              var s = dates.start_date;
              var e = dates.end_date;

              //if empty
              if (!s || !e) {
                return false;
              }

              s = s.replace(/-/g, " ");
              s = new Date(s).getTime();

              e = e.replace(/-/g, " ");
              e = new Date(e).getTime();


              //check if start_date is greater that end date;
              if (s > e) {
                return false;
              }
              return true;
            }
        }
    }
</script>
